import { checkoutApi } from '../../api';
import { ecommerce } from '../../utils/analytics/ecommerce';

export const PAY = 'CHECKOUT:PAY';
export const PAY_SUCCESS = 'CHECKOUT:PAY_SUCCESS';
export const PAY_FAILURE = 'CHECKOUT:PAY_FAILURE';

const actions = {
  subscribeExpertMessages: {
    handle: (result = {}) => {
      ecommerce(result.deliveryOrders);
    },
    event: 'ecommerceCashOrder',
  },
  subscribePaymentResult: {
    handle: (paymentResult = {}) => {
      const { setPaymentResult } = (paymentResult && paymentResult.data) || {};
      const deliveryOrders = setPaymentResult && setPaymentResult.data && setPaymentResult.data.deliveryOrders;
      ecommerce(deliveryOrders);
    },
    event: 'setPaymentResult',
  },
  pay: (options) => dispatch => {
    dispatch({
      type: PAY,
      payload: options,
    });

    const onSuccess = (paymentSuccess) => {
      const { options } = paymentSuccess;
      dispatch({
        type: PAY_SUCCESS,
        payload: options,
      });
      checkoutApi.setPaymentResult(true, options);
    }

    const onError = ({ reason, options }) => {
      dispatch({
        type: PAY_FAILURE,
        payload: { options, reason },
      });
      checkoutApi.setPaymentResult(false, options, reason);
    }

    checkoutApi.pay(options, onSuccess, onError);
  },
  addEcommerceSubscription: () => dispatch => {
    dispatch(actions.subscribeExpertMessages);
    dispatch(actions.subscribePaymentResult);
  }
};

export default actions;
